/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useContext } from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { AppContext } from "../context/context"

function SEO({ description, lang, meta, title, noIndex = false }) {
  const { site, settings } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        settings: kontentItemSettings {
          elements {
            favicon {
              value {
                url
              }
            }
          }
        }
      }
    `
  )

  const favicon = settings.elements.favicon.value[0].url
  const metaDescription = description || site.siteMetadata.description

  const { siteUrl } = useContext(AppContext)
  if (siteUrl === "https://aroostook.lobstermarketing.com") {
    noIndex = true
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    >
      <meta name="description" content={metaDescription} />
      <meta
        property="og:title"
        content={`${title} | ${site.siteMetadata.title}`}
      />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={site.siteMetadata.siteUrl} />
      <meta
        property="og:image"
        content={settings.elements.favicon.value[0].url}
      />
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      {noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}
export default SEO
